<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vSzlD3VTM3ZGGvvNUgPkKSvw7yJb_iEqx8qaIgCx5LDSnlyqXPVlw3P7HE2F3K-EgCGLWGhdovBFPYG/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>